import { connect } from "react-redux";
import { StepSelect as Component } from "../StepSelect";
import { ddqSetOption, ddqSubmit } from "@learningblocks/exp-redux";

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    onDropdownSelect: (params) => {
      dispatch(ddqSetOption(params));
    },
    submitAnswer: (id, type) => {
      dispatch(ddqSubmit(id, type));
    },
  };
}

export const StepSelectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
